import script from "./outbound-type-chart.vue?vue&type=script&setup=true&lang=ts"
export * from "./outbound-type-chart.vue?vue&type=script&setup=true&lang=ts"

import "./outbound-type-chart.vue?vue&type=style&index=0&id=24df9edb&lang=scss&scoped=true"

import exportComponent from "/data/build/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-24df9edb"]])

export default __exports__